import styled from 'styled-components'

import BaseBtn from '../BaseBtn'

export default styled(BaseBtn)`
  width: 125px;
  background: ${p => p.theme.colors.$whiteSmoke};
  color: ${p => p.theme.colors.$nightRider};
`
